import commentReducer from './reducers';
import commentSaga from './saga';
import { reduxModuleLoaded } from './actionCreators';
export function getCommentModule() {
    return {
        id: 'commentModule2',
        reducerMap: commentReducer,
        sagas: [
            commentSaga
        ],
        initialActions: [
            reduxModuleLoaded()
        ],
        retained: false
    };
}

//# sourceMappingURL=module.js.map